import mutations from './item/mutations';
import actions from './item/actions';
import getters from './item/getters';

const item = {
  namespaced: true,
  state: {
    item: {
      title: null,
      description: null,
      covers: null,
      numberOfQuestions: null,
      passRate: null,
      template: null,
      questions: [],
    },
    isLoading: false,
  },
  mutations,
  actions,
  getters,
};

export default item;
